import { CurrencyPipe } from '@angular/common';
import { Component, Input, inject, output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { GravatarModule } from 'ngx-gravatar';
import { LazyLoadDirective } from '@bn/web-ui';
import { BnClipboardService } from '@bn/web-ui/common-web/services';
import { DropdownMenuComponent } from '@bn/web-ui/dropdown-menu/dropdown-menu.component';
import { DropdownMenuItem } from '@bn/web-ui/dropdown-menu/models';
import { BadgeComponent } from '@bn/web-ui/badge/badge.component';

@Component({
  standalone: true,
  selector: 'bn-layout-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
  imports: [CurrencyPipe, RouterLink, RouterLinkActive, GravatarModule, DropdownMenuComponent, FaIconComponent, LazyLoadDirective, BadgeComponent],
})
export class UserProfileComponent {
  private readonly clipboard = inject(BnClipboardService);

  @Input() menuItems: DropdownMenuItem[] = [];
  @Input() isMobile = false;
  @Input() email = '';
  @Input() fullName = '';
  @Input() accountRoute?: string;
  @Input() billingRoute?: string;
  @Input() billingBalance?: number;
  @Input() showBilling = false;

  readonly logout = output<void>();

  public onItemClick(menuItem: DropdownMenuItem): void {
    if (menuItem.action === 'logout') {
      // TODO: The 'emit' function requires a mandatory void argument
      this.logout.emit();
    }
  }

  public copyToClipboard(): void {
    this.clipboard.copyTextToClipboard(this.email, 'Email');
  }
}
